import { Component, Input, OnInit } from '@angular/core'
import { MBTI } from 'src/app/interfaces/mbti'

@Component({
  selector: 'mbti-tag',
  template: `
    <div
      *ngIf="this.mbti !== undefined; else empty"
      class="mbti-tag"
      [ngStyle]="{
        width: this.width / 16 + 'rem',
        height: this.height / 16 + 'rem',
        'border-radius': this.width * 0.32 + 'px'
      }"
      [style]="this.mbti | mbtiColor : 'background-color'"
    >
      <img
        class="mbti-img"
        [ngStyle]="{ width: this.imageSize / 16 + 'rem', height: this.imageSize / 16 + 'rem' }"
        [src]="'assets/icons/mbti/no_colored_mbti/' + this.mbti + '.png' | imageUrl"
      />
      <div class="mbti" [ngStyle]="{ 'font-size': this.fontSize / 16 + 'rem' }">{{ this.mbti }}</div>
    </div>
    <ng-template #empty>
      <div
        class="mbti-tag empty"
        [ngStyle]="{
          width: this.width / 16 + 'rem',
          height: this.height / 16 + 'rem',
          'border-radius': this.width * 0.32 + 'px'
        }"
      >
        <div class="mbti" [ngStyle]="{ 'font-size': this.fontSize / 16 + 'rem' }">XXXX</div>
      </div>
    </ng-template>
  `,
  styles: [
    `
      .mbti-tag {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
      }
      .mbti-img {
      }
      .mbti {
        margin-left: 0.5rem;
        color: var(--white);
      }
      .empty {
        background-color: var(--grey-20);
      }
    `,
  ],
})
export class MbtiTagComponent implements OnInit {
  constructor() {}

  @Input() mbti: MBTI | undefined
  @Input() imageSize = 24
  @Input() fontSize = 24
  @Input() width = 128
  @Input() height = 42

  ngOnInit(): void {}
}
